'use client'
import React, { useEffect } from 'react'
// import { Video } from '@components'
import { AiFillCloseSquare } from 'react-icons/ai'
import tailwindConfig from '@tailwind.config'
import Image from "next/image";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { Dialog } from '@headlessui/react'

const Gallery = ({ isOpen, onClose, gallery, videoUrl, initialSlide }) => {
    // if (!isOpen) return null;
    let width = 0
    if (typeof window !== "undefined") {
        width = window.innerWidth
      }

    return (
        <Dialog className='w-full z-[1000] inset-0' open={isOpen} onClose={onClose}>
            <div className="fixed inset-0 bg-black/80  z-[1000]" aria-hidden="true" onClick={onClose} />
            <div className='fixed left-[50%] translate-x-[-50%] sm:translate-y-[100px] translate-y-[50%]  z-[1000] inset-0 flex sm:w-[1000px] w-full aspect-[4/3] items-center justify-center rounded-md overflow-hidden'>
                <Dialog.Panel className='w-full h-full'>
                <div className='flex w-full h-full group justify-center items-center  z-[1000]'>
                    <Swiper
                        className='sm:w-[1000px] w-full h-full rounded-md overflow-hidden z-[1000]'
                        navigation={width > 450 ? true : false}
                        modules={[Navigation]}
                        initialSlide={initialSlide || 0}
                    >
                        {gallery && gallery.map((image, index) => (
                            <SwiperSlide key={index} className='flex items-center justify-center'>
                                <div className="relative flex h-full justify-center items-center">
                                    <div className='relative'>
                                        <div className='absolute hidden sm:group-hover:block bg-maincolor z-[1000] top-0 right-0 border-none hover:cursor-pointer rounded-md overflow-hidden'>
                                            <span className='border-none active:border-none ' onClick={onClose}>
                                                <AiFillCloseSquare
                                                    color={tailwindConfig.theme.extend.colors.light}
                                                    size={40}
                                                />
                                            </span>
                                        </div>
                                        <Image
                                            src={image}
                                            // src={`https://rstbase.com/images/properties/${propertyId}/${image}`}
                                            alt="image"
                                            width={1000}
                                            height={667}
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                </Dialog.Panel>
            </div>
      </Dialog>
    )
}

export default Gallery